import { useContext } from 'react';

import { AuthContext, type Auth } from './AuthContext';

export const useAuth = (): Auth => {
  const auth = useContext(AuthContext);

  if (!auth) {
    throw new Error('useAuth must be used inside AuthProvider.');
  }

  return auth;
};
